import React from 'react';
import { TableCell, Typography } from '@mui/material';
import { formatValueWithResolution, formatDisplayValue } from './utils';

type NominalValueCellProps = {
  nominal: number | null;
  label?: string;
  resolution?: number;
  unit: string;
};

export const NominalValueCell: React.FC<NominalValueCellProps> = ({
  nominal,
  label,
  resolution,
  unit
}) => (
  <TableCell>
    <Typography variant="body2" fontWeight={600}>
      {label ??
        `${
          resolution !== undefined
            ? formatValueWithResolution(nominal, resolution)
            : formatDisplayValue(nominal)
        } ${unit}`}
    </Typography>
  </TableCell>
);
